<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>To John and Jeff, brothers, friends and fellow travelers on the journey through life.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?242e6b1a